import {ReactElement} from "react";
import {RendererProps} from "../RendererProps";
import {AddOrSetRenderHelper} from "./AddOrSetRenderHelper";

export function RenderAccountValueOverride(props: RendererProps): ReactElement {
    return <AddOrSetRenderHelper {...props} />;
}